/*
 * winamp-init.js — boots Webamp (https://webamp.org) on the Winamp product page.
 *
 * Self-hosted: the Webamp library is vendored at assets/webamp.bundle.min.js
 * (the all-in-one UMD bundle, which inlines the skin so nothing is fetched from
 * an external CDN). The only network requests are the song files, which are
 * your own Shopify-hosted MP3s.
 *
 * The playlist is injected by sections/winamp.liquid as window.WINAMP_TRACKS:
 *   [{ url: "<mp3 url>", title: "Artist - Title" }, ...]
 *
 * Load order (both deferred, after the inline WINAMP_TRACKS script):
 *   webamp.bundle.min.js  ->  winamp-init.js
 */
(function () {
  "use strict";

  function start() {
    var Webamp = window.Webamp;
    var container = document.getElementById("winamp-app");
    if (!Webamp || !container) return;

    // Webamp needs Web Audio + a few modern APIs; bail gracefully if missing.
    if (Webamp.browserIsSupported && !Webamp.browserIsSupported()) {
      container.innerHTML =
        '<p style="font-family:monospace">Your browser can\'t run Winamp. ' +
        "Try a desktop browser.</p>";
      return;
    }

    var tracks = (window.WINAMP_TRACKS || [])
      .filter(function (t) {
        return t && t.url;
      })
      .map(function (t) {
        return {
          url: t.url,
          metaData: { artist: t.artist || "", title: t.title || "" },
        };
      });

    var webamp = new Webamp({
      initialTracks: tracks.length ? tracks : undefined,
      // Stack the three windows vertically so they sit tidily in the page
      // instead of the default top-left viewport pile.
      __initialWindowLayout: {
        main: { position: { x: 0, y: 0 } },
        equalizer: { position: { x: 0, y: 116 } },
        playlist: { position: { x: 0, y: 232 }, size: [0, 4] },
      },
    });

    webamp
      .renderWhenReady(container)
      .then(function () {
        if (window.WINAMP_AUTOPLAY !== false) autoplay(webamp);
      })
      .catch(function (e) {
        if (window.console) console.warn("[winamp] failed to render", e);
      });
  }

  // Browsers block autoplay-with-sound until the user interacts with the page.
  // So we attempt playback immediately (works if the browser allows it), and
  // also arm a one-time "start on first interaction" fallback so the music
  // kicks in the moment the visitor clicks, taps, or presses a key.
  function autoplay(webamp) {
    if (typeof webamp.play !== "function") return;

    try {
      webamp.play();
    } catch (e) {
      /* blocked — the interaction fallback below will cover it */
    }

    var EVENTS = ["pointerdown", "keydown", "touchstart"];
    var started = false;
    function kick() {
      if (started) return;
      started = true;
      try {
        webamp.play();
      } catch (e) {}
      EVENTS.forEach(function (ev) {
        document.removeEventListener(ev, kick, true);
      });
    }
    EVENTS.forEach(function (ev) {
      document.addEventListener(ev, kick, true);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
